/**
 * Continue on the welcome wizard's Connect step used to be a pure local step
 * change (`setStep("agents")`), even when the account's only Environment was
 * suspended, indistinguishable, from the outside, from doing nothing
 * (CMMD-Center/forge#3626).
 *
 * Waking a suspended Environment from here is not available without the
 * sidebar's full connect plumbing (`SidebarPreConnectCloudMetadata`,
 * including a `cmmdProjectId` the wizard never has). The one action reachable
 * with only an organization id, `ensureSeatEnvironment`, reuses the existing
 * row for an already-provisioned Environment rather than provisioning a
 * second one, but for a row that already has a `spriteName` and is not
 * `error` or `destroyed`, `ensureRuntimeMachine` only asks the substrate
 * whether the machine still exists, a control-plane read that CMMD's own
 * code comments say does not wake a suspended machine. It is not a wake
 * action.
 *
 * A returning account with a suspended Environment already has one on
 * record and does not need first-run onboarding. Continue skips the rest of
 * the wizard and finishes it instead.
 */
export interface ConnectStepEnvironment {
  readonly status: string;
}

/** Whether Continue on the Connect step should skip the rest of the wizard. */
export function shouldSkipWizardOnContinue(
  environments: readonly ConnectStepEnvironment[],
): boolean {
  return environments.some((environment) => environment.status === "suspended");
}
